module.exports = __webpack_public_path__ + "img/AdobeStock_302682764.aa37d759.png";